import React from "react";
import styled from "styled-components";
import { Spinner } from "@blueprintjs/core";

const Container = styled.section`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LoadingView: React.FC = () => (
  <Container>
    <div>
      <Spinner intent="primary" size={60} />
      <div className="loading-text-m">Semgrep App is loading</div>
    </div>
  </Container>
);
